// extracted by mini-css-extract-plugin
export var fadeIn = "_lr-1";
export var modalContent = "_lr-3";
export var overlay = "_lr-0";
export var popoverContent = "_lr-2";
export var results = "_lr-5";
export var searchInputWrapper = "_lr-4";